import { Icons } from '../icons/icons';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const StaticTableRow = (row: any): JSX.Element => {
  return (
    <tr className="static-row" {...row.getRowProps?.()}>
      {row.cells?.map?.((cell: any, index: number) => {
        if (index === 0) {
          return (
            <td className="static-row-data body-cell" {...cell.getCellProps()}>
               <Icons.Drag />
              <span>{cell.render('Cell')}</span>
            </td>
          );
        }
        return (
          <td className="static-row-data body-cell" {...cell.getCellProps()}>
            {cell.render('Cell')}
          </td>
        );
      })}
    </tr>
  );
};
